import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResult } from "@app/shared/model/apiresult";
import { Guid } from "guid-typescript";
import { catchError, map } from 'rxjs/operators';
import { environment as env } from '@environments/environment'
import { throwError } from "rxjs";
import { IPersonPhone } from "../model/personphone";

@Injectable({ providedIn: 'root' })

export class PersonPhoneService {
    constructor(private http: HttpClient) { }

    get(personId: Guid) {
        return this.http.get<ApiResult<IPersonPhone[]>>(env.apiUrl + 'PersonPhone/' + personId);
    }
    post(studentDocument: IPersonPhone) {
        return this.http.post<ApiResult<number>>(env.apiUrl + 'PersonPhone', studentDocument).pipe(catchError(this.handleError))
    }
    put(studentDocument: IPersonPhone) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'PersonPhone', studentDocument);
    }
    delete(id: Guid) {
        return this.http.delete<ApiResult<any>>(env.apiUrl + 'PersonPhone/' + id);
    }
    handleError(error: HttpErrorResponse) {
        return throwError(error);
    }
}